// src/components/About.js
import React from 'react';
import '../App.css';

const KwachaLogo = () => (
  <svg width="300" height="200" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 20V80M70 20V80M30 50H70" stroke="#2E7D32" strokeWidth="5" />
    <path d="M40 30L60 70" stroke="#FFB300" strokeWidth="5" />
  </svg>
);

const About = () => (
  <section className="about-section">
    <div className="content-wrapper">
      <h2 className="section-title">FugiPay: It's more Personal</h2>
      <div className="about-flex">
        <div className="about-text">
          <p className="about-description">
            FugiPay makes it easy to pass money in a personal way. Using modern technology, you can make digital payments to people close to you (person to person), and pay businesses (person to business) in a personal way that feels more human 🫳🏾. Built on trust and innovation.
          </p>
          <ul className="about-features">
            <li><span className="feature-icon">📱</span> Instant QR code payments</li>
            <li><span className="feature-icon">🫳🏾</span> Nearby money pass (NFC)</li>
            <li><span className="feature-icon">💸</span> Swift, dependable transfers</li>
          </ul>
        </div>
        <div className="about-image-wrapper">
          <KwachaLogo />
        </div>
      </div>
    </div>
  </section>
);

export default About;